import React from "react";

const Minutadmin = () => {
  return <div></div>;
};

export default Minutadmin;
